<template>
    <div class="shadow-sm p-3 mb-3">
        <div class="text-white text-center" :class="check.validated ? 'bg-success' : 'bg-primary'">
            <h5> Chèque Nº : <span class="fw-bold">{{ check.checkNumber }}</span></h5>
        </div>

        <div class="mt-3">
            <div class="row">
                <div class="col-md-6">
                    <ul class="list-unstyled">
                        <li>Référence : <strong class="fw-bold">{{ check.reference }}</strong></li>
                        <li>Client : <strong class="fw-bold">{{ check.customerFullName }}</strong></li>
                        <li>Nom complet : <strong class="fw-bold">{{ check.fullName || 'N/A' }}</strong></li>
                        <li>Montant : <strong class="fw-bold">{{ parseFloat(check.amount).toFixed(2) }} MAD</strong></li>
                        <li>Montant écrit : <strong class="fw-bold">{{ check.writtenAmount }}</strong></li>
                        <li>Banque : <strong class="fw-bold">{{ check.bank || 'Non spécifiée' }}</strong></li>
                        <li>Date d'émission : <strong class="fw-bold">{{ check.date }}</strong></li>
                        <li>Échéance : <strong class="fw-bold">{{ check.deadline || 'N/A' }}</strong></li>
                        <li>Remarque : <strong class="fw-bold">{{ check.remark || 'Aucune' }}</strong></li>
                    </ul>
                </div>

                <div class="col-md-6">
                    <ul class="list-unstyled">
                        <li>Statut : <strong class="fw-bold">{{ check.status }}</strong></li>

                        <li>Vérifié :
                            <strong class="fw-bold">{{ check.checked ? 'Oui' : 'Non' }}</strong>
                            <span v-if="check.checkedDateTime">({{ check.checkedDateTime }})</span>
                        </li>
                        <li>Validé :
                            <strong class="fw-bold">{{ check.validated ? 'Oui' : 'Non' }}</strong>
                            <span v-if="check.validationDateTime">({{ check.validationDateTime }})</span>
                        </li>
                        <li>Référence utilisateur : <strong class="fw-bold">{{ check.userFullName }}</strong></li>
                        <li>Créé le : <strong class="fw-bold">{{ check.created_at }}</strong></li>
                        <li>Mis à jour : <strong class="fw-bold">{{ check.updated_at }}</strong></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        check: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.card {
    border-radius: 0.75rem;
}
</style>
